import React from 'react';
import {
  Section,
  SectionContent,
  SectionTitle,
  SectionSubtitle,
  SectionDescription,
  WhyPlayfair,
  WhyItem,
  WhyIcon,
  WhyTitle,
  WhyText,
} from '../styles/sections';

function WhyPlayfairSection() {
  const whyItems = [
    { emoji: '🏆', title: 'Performance Excellence', text: 'Streamline fine management to keep your team focused and accountable.' },
    { emoji: '👥', title: 'Community & Support', text: 'Build team spirit with transparent tracking and fun interactions.' },
    { emoji: '💚', title: 'Motivation & Fun', text: 'Humorous notifications and rewards to keep everyone engaged.' },
    { emoji: '🏋️', title: 'Innovation', text: 'Advanced tools for modern sport team management.' },
  ];

  return (
    <Section id="why-playfair" backgroundColor="#f0efea">
      <SectionContent>
        <SectionSubtitle style={{ color: '#000' }}>Why Choose Us</SectionSubtitle>
        <SectionTitle style={{ color: '#000' }}>
          The Ultimate Sport <br /> Fines App
        </SectionTitle>
        <SectionDescription style={{ color: '#000' }}>
          We are more than just a fines app — we are a community built for accountability,
          fun, and excellence on the pitch.
        </SectionDescription>
        <WhyPlayfair>
          {whyItems.map((item) => (
            <WhyItem key={item.title} whileHover={{ y: -5 }}>
              <WhyIcon>{item.emoji}</WhyIcon>
              <WhyTitle>{item.title}</WhyTitle>
              <WhyText>{item.text}</WhyText>
            </WhyItem>
          ))}
        </WhyPlayfair>
      </SectionContent>
    </Section>
  );
}

export default WhyPlayfairSection;
